// axios
import axios from "axios";
import queryString from 'query-string';
import jwtToken from "./core/helpers/jwtToken";
import authService from "./core/services/authService";

/** @type {Array} */
let requestsToRefresh = [];
/** @type {boolean} */
let isRefreshToken = false;

const instanceAxios = axios.create({
    baseURL: `${window.BASE_URL}/api`,
    paramsSerializer: (params) => queryString.stringify(params),
    headers: {
        Authorization: `Bearer ${jwtToken.getToken()}`
    }
});

instanceAxios.interceptors.request.use(req => {
    // Add configuration here with spread object
    req.headers = {
        ...req.headers,
        Authorization: `Bearer ${jwtToken.getToken()}`
    };
    return req;
});

instanceAxios.interceptors.response.use(res => {
    return res;
}, (error) => {
    const { response, config } = error;
    const { status } = response;

    // The account not active
    if(status === 406) {
        jwtToken.removeToken();
        return window.location.href = "/login";
    }

    // 1. Should refresh token when status response 401
    // if status is response code 401, we need to send request token here
    if(status === 401) {
        if(!jwtToken.isHasToken()) {
            return Promise.reject(error);
        }

        // 1.1 refresh token is false, to call refresh token api
        if(!isRefreshToken) {
            // @todo update status isRefresh to be true
            isRefreshToken = true;
            
            // 2. Once time to call refresh token api
            // @todo send request to refresh token here
            authService.refreshToken().then(({ access_token }) => {
                requestsToRefresh.forEach((callback) => {
                    callback(access_token);
                });

                // 4. Push access_token for callback in step 3
            }).catch((error) => {
                jwtToken.removeToken();
                requestsToRefresh.forEach((cb) => cb(null));
            }).finally(() => {
                // 5. After that, to clear all setup
                isRefreshToken = false;
                requestsToRefresh = [];
            });   
        }

        // 3. Setup callback to change token in headers authorization
        return new Promise((resolve, reject) => {
            requestsToRefresh.push((token) => {
                if(token) {
                    // Reset access_token for another request behind
                    config.headers.Authorization = "Bearer " + token;
                    resolve(instanceAxios(config));
                }

                reject(error);
            });
        })
    }
    else {
        return Promise.reject(error);
    }
});

export default instanceAxios;



// WEBPACK FOOTER //
// ./src/axios.js